"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { LayoutDashboard, Boxes, Users, Smartphone } from "lucide-react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/components/i18n-provider";

// Раздел «Доступы» (module: "access") виден только SD — HR его не получает.
// Настройки портала живут под логотипом, отдельного пункта в меню у них нет.
export function NavLinks({ showAccess }: { showAccess: boolean }) {
  const { dict } = useI18n();
  const pathname = usePathname();

  const all = [
    { href: "/", label: dict.nav.dashboard, icon: LayoutDashboard, exact: true, module: "inventory" as const },
    { href: "/people", label: dict.nav.people, icon: Users, exact: false, module: "access" as const },
    { href: "/assets", label: dict.nav.assets, icon: Boxes, exact: false, module: "inventory" as const },
    { href: "/esim", label: dict.nav.esim, icon: Smartphone, exact: false, module: "access" as const },
  ];
  const links = all.filter((l) => l.module === "inventory" || showAccess);

  return (
    <nav className="flex items-center gap-0.5 text-sm sm:gap-1">
      {links.map((l) => {
        const active = l.exact ? pathname === l.href : pathname.startsWith(l.href);
        const Icon = l.icon;
        return (
          <Link
            key={l.href}
            href={l.href}
            className={cn(
              "flex items-center gap-1.5 rounded-lg px-2 py-1.5 font-medium transition-colors sm:px-3",
              active ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            <Icon className="size-4" />
            <span className="hidden sm:inline">{l.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
